var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":"addProducto","title":"AÑADIR PRODUCTO"},on:{"close":() => _vm.close(false)}},[_c('FormComponent',{attrs:{"producto":_vm.producto,"products":_vm.products,"desactivar":false},on:{"update:producto":function($event){_vm.producto=$event},"terminado":_vm.addProducto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }